interface Props {
  loading: boolean;
  suggestions: any;
  onApply: (text: string) => void;
}

const AISuggestionPanel = ({ loading, suggestions, onApply }: Props) => {
  if (loading) {
    return (
      <div className="mt-2 text-xs text-gray-400">
        Checking for improvements…
      </div>
    );
  }

  if (!suggestions) return null;

  const { hasSuggestions, grammar, tones } = suggestions;

  if (!hasSuggestions) {
    return (
      <div className="mt-2 text-xs text-gray-400">
        No corrections suggested.
      </div>
    );
  }

  return (
    <div className="mt-3 p-3 rounded-xl border bg-white shadow-sm space-y-3">

      {grammar && (
        <div>
          <p className="text-xs font-semibold text-gray-700 mb-1">
            Suggested correction
          </p>
          <div className="flex items-center justify-between gap-2">
            <p className="text-sm text-gray-800">{grammar}</p>
            <button
              onClick={() => onApply(grammar)}
              className="text-xs text-blue-600 hover:underline"
            >
              Apply
            </button>
          </div>
        </div>
      )}

      {tones && (
        <div>
          <p className="text-xs font-semibold text-gray-700 mb-1">
            Tone suggestions
          </p>

          <div className="space-y-1">
            {Object.entries(tones).map(([tone, value]) => (
              <div
                key={tone}
                className="flex items-center justify-between gap-2"
              >
                <p className="text-sm text-gray-700">
                  <span className="capitalize font-medium">{tone}:</span>{" "}
                  {value as string}
                </p>
                <button
                  onClick={() => onApply(value as string)}
                  className="text-xs text-blue-600 hover:underline"
                >
                  Apply
                </button>
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default AISuggestionPanel;
